import React from 'react';
import {Typography} from '@bonprix/design-system';

export default function CartItemPricePerUnit({price, texts}) {
    const perUnitText = price ? ' / ' + texts.cot_item : '';

    return (
        <div className="cart-item-details__price-per-unit">
            <Typography component='span'>
                {price}
                {perUnitText}
            </Typography>
        </div>
    );
}
